import { render, staticRenderFns } from "./ScoringIntegrityIssueLinks.vue?vue&type=template&id=ef0a636c&"
import script from "./ScoringIntegrityIssueLinks.vue?vue&type=script&lang=js&"
export * from "./ScoringIntegrityIssueLinks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports